import React from "react";
import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";
import { Select } from "@/components/elements";

interface Data { name: string, value: number };

const dataQuery = `
select label as name, count(*) as value
from events
where label in ('notification', 'open_notification', 'dismiss_notification')
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
group by label;

`;

const extractUsersQuery = `
select distinct user_id
from events where type = 'event'
and label = ?
and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
`

export function NotificationsChart() {
  let type: 'include' | 'exclude' | '' = '';
  return <SqlDataTable
    label="Notifications"
    subtext="Notifications events(Incomplete data until more people update their apps) (Last 7 days)"
    width={900}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <UserExportHeader onType={t => type = t} data={data.name}/>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.name])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(d => {
            if(type === 'exclude') {
              return users.has(d.id) === false;
            } else {
              return users.has(d.id) === true;
            }
          });
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}


interface UserExportHeaderProps {
  data: string;
  onType: (type: 'include' | 'exclude') => void;
}

function UserExportHeader(props: UserExportHeaderProps) {
  const [type, setType] = React.useState<'include' | 'exclude'>('include');

  const options = React.useMemo(() => {
    const options: {label: string, value: string}[] = [
      {label: `Include only users in the ${props.data} event.`, value: 'include'},
      {label: `Exclude the users in the ${props.data} event`, value: 'exclude'},
    ];

    return options;
  }, []);

  React.useEffect(() => {
    props.onType(type);
  }, [type]);

  return <>
    Filter: 
    <Select
      size="small"
      value={type}
      changeEvent={e => setType(e.target.value as any)}
      options={options}/>
  </>
}